// WhoThisIsFor.js
import React from 'react';
import { motion } from 'framer-motion';
import { Users, Briefcase, Globe } from 'lucide-react';

const WhoThisIsFor = () => {
  const audiences = [
    {
      icon: Users,
      title: 'Care and Healthcare Support Workers',
      description: 'Professionals in care and healthcare support roles looking for international opportunities'
    },
    {
      icon: Briefcase,
      title: 'Skilled and Semi-Skilled Professionals',
      description: 'Qualified professionals with relevant experience in their field'
    },
    {
      icon: Globe,
      title: 'Candidates Open to Relocation',
      description: 'Individuals ready for international employment and relocation'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Left Column - Heading */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-6">
              Who This Service Is For
            </h2>
          </motion.div>

          {/* Right Column - Audience List */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-6"
          >
            {audiences.map((audience, index) => {
              const Icon = audience.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.3 + (index * 0.1) }}
                  className="flex items-start gap-4"
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-[#F5F8FA] rounded-lg flex items-center justify-center">
                    <Icon size={24} className="text-[#202356]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[#202356] mb-2">
                      {audience.title}
                    </h3>
                    <p className="text-gray-600 text-sm font-light">
                      {audience.description}
                    </p>
                  </div>
                </motion.div>
              );
            })}

            {/* Eligibility Note */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.6 }}
              className="mt-8 p-6 bg-[#F5F8FA] rounded-lg"
            >
              <p className="text-gray-700 text-sm font-normal italic">
                Not all applicants will qualify. Eligibility is assessed during consultation to ensure alignment with employer requirements.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsFor;
